// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 客户策略基础详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/base-info */
export async function customerStrategyBaseInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyBaseInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCustomerStrategyDetailResp>('/customer-strategy/base-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 校验上报状态 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/check-upload-status */
export async function customerStrategyCheckUploadStatusUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultVoid>('/customer-strategy/check-upload-status', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 择时记录 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/choose-time/record */
export async function customerStrategyChooseTimeRecordUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyChooseTimeRecordUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyChooseTimeRecordInfoResp>(
    '/customer-strategy/choose-time/record',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 客户策略详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/detail */
export async function customerStrategyDetailUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyDetailUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCustomerStrategyDetailResp>('/customer-strategy/detail', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 设备信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/device-info */
export async function customerStrategyDeviceInfoUsingGET(options?: { [key: string]: any }) {
  return request<API.BaseResultStrategyDeviceInfoResp>('/customer-strategy/device-info', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 客户策略详情 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/info */
export async function customerStrategyInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultUserStrategyResp>('/customer-strategy/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 通道总概览 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/passageway/info */
export async function customerStrategyPassagewayInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyPassagewayInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCustomerPassagewayInfoResp>('/customer-strategy/passageway/info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 客户通道列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/passageway/list */
export async function customerStrategyPassagewayListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyPassagewayListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCustomerPassagewayResp>('/customer-strategy/passageway/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取策略收益曲线信息 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/revenue/line */
export async function customerStrategyRevenueLineUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyRevenueLineUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListRatioResp>('/customer-strategy/revenue/line', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户策略仿真运算 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/simulate-info */
export async function customerStrategySimulateInfoUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategySimulateInfoUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategySimulateInfoResp>('/customer-strategy/simulate-info', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取用户策略仿真运算历史明细 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/simulate/passageways/orders */
export async function customerStrategySimulatePassagewaysOrdersUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategySimulatePassagewaysOrdersUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategySimulateTradeDetailInfoResp>(
    '/customer-strategy/simulate/passageways/orders',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 客户持仓 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/stock/list */
export async function customerStrategyStockListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyStockListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCustomerStockDetailResp>('/customer-strategy/stock/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 财达策略订阅列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/subscription/cd-list */
export async function customerStrategySubscriptionCdListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategySubscriptionCdListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListCdUserStrategySubscriptionExportResp>(
    '/customer-strategy/subscription/cd-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 策略订阅列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/subscription/list */
export async function customerStrategySubscriptionListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategySubscriptionListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.PageResultListStrategySubscriptionResp>(
    '/customer-strategy/subscription/list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 策略模板消息列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/template/list */
export async function customerStrategyTemplateListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTemplateListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultCustomerStrategyTemplateResp>('/customer-strategy/template/list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 今日调仓列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/today-trade-list */
export async function customerStrategyTodayTradeListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTodayTradeListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyOrderDetailResp>('/customer-strategy/today-trade-list', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 今日调仓计划列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/today-trade-plan-list */
export async function customerStrategyTodayTradePlanListUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTodayTradePlanListUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCustomerStockTradePlanResp>(
    '/customer-strategy/today-trade-plan-list',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取客户交易通道列表 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/trade/passageways */
export async function customerStrategyTradePassagewaysUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTradePassagewaysUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListStrategyPassagewayStatisticsResp>(
    '/customer-strategy/trade/passageways',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}

/** 获取客户交易记录 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/trade/record */
export async function customerStrategyTradeRecordUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTradeRecordUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultListCustomerTradeRecordResp>('/customer-strategy/trade/record', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 获取客户收益统计 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /customer-strategy/trade/revenue-statistics */
export async function customerStrategyTradeRevenueStatisticsUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.customerStrategyTradeRevenueStatisticsUsingGETParams,
  options?: { [key: string]: any },
) {
  return request<API.BaseResultStrategyRevenueStatisticsResp>(
    '/customer-strategy/trade/revenue-statistics',
    {
      method: 'GET',
      params: {
        ...params,
      },
      ...(options || {}),
    },
  );
}
